__turbopack_context__.v({
  "loadCircle": "EqualizerCalculatorModal-module-scss-module__wqmSEG__loadCircle",
  "modal": "EqualizerCalculatorModal-module-scss-module__wqmSEG__modal",
  "modal__benefits": "EqualizerCalculatorModal-module-scss-module__wqmSEG__modal__benefits",
  "modal__closeBtn": "EqualizerCalculatorModal-module-scss-module__wqmSEG__modal__closeBtn",
  "modal__inner": "EqualizerCalculatorModal-module-scss-module__wqmSEG__modal__inner",
  "modal__title": "EqualizerCalculatorModal-module-scss-module__wqmSEG__modal__title",
  "overlay": "EqualizerCalculatorModal-module-scss-module__wqmSEG__overlay",
});
